'use client';

import React from 'react';
import { RegFormField } from '@/features/b2b/register/components/RegFormField';

export const CompanyDetailsForm = ({ formData, handleInputChange, lookupState, handleFcaReset }) => {
  return (
    <>
      <RegFormField
        label="Company status"
        name="companyStatus"
        value={formData.companyStatus}
        onChange={handleInputChange}
        placeholder="Authorised"
        readOnly
      />

      <RegFormField
        label="Company name"
        name="name"
        value={formData.name}
        onChange={handleInputChange}
        placeholder="Example LTD"
        readOnly
      />

      <RegFormField
        label="Company phone number"
        name="phone"
        type="tel"
        value={formData.phone}
        onChange={handleInputChange}
        placeholder="07803 675 543"
        readOnly
      />

      <RegFormField
        label="Address line 1"
        name="al1"
        value={formData.al1}
        onChange={handleInputChange}
        placeholder="123 Main Street"
        readOnly
      />

      <RegFormField
        label="Address line 2"
        name="al2"
        value={formData.al2}
        onChange={handleInputChange}
        placeholder="Suite 456"
        readOnly
      />

      <RegFormField
        label="Town/City"
        name="town"
        value={formData.town}
        onChange={handleInputChange}
        placeholder="London"
        readOnly
      />

      <div className="md:flex md:gap-2">
        <div>
          <RegFormField
            label="County (If applicable)"
            name="county"
            value={formData.county}
            onChange={handleInputChange}
            placeholder="Westminster"
            readOnly
            className={lookupState !== 'done' ? '' : 'md:mb-2'}
          />
        </div>

        <div>
          <RegFormField
            label="Postcode"
            name="postcode"
            value={formData.postcode}
            onChange={handleInputChange}
            placeholder="SW1A 1AA"
            readOnly
            className={lookupState !== 'done' ? '' : 'mb-2'}
          />
        </div>
      </div>

      <p className={`flex text-[#006EB7] text-sm font-medium mb-6${lookupState !== 'done' ? ' hidden' : ''}`}>
        <span className="pr-2">Re-enter FCA number</span>
        <button
          type="button"
          id="fcaReset"
          onClick={handleFcaReset}
          aria-label="Re-enter FCA number"
          className="appearance-none bg-transparent border-0 p-0 m-0 cursor-pointer"
        >
          <img
            src="/img/icons/refresh-cw-05.svg"
            alt=""
            className="pointer-events-none"
          />
        </button>
      </p>
    </>
  );
};
